/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_H1Inputs */

const en_funnel_sq_h1 = /** @type {(inputs: Funnel_Sq_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get through your [research papers] without reading them.`)
};

const es_funnel_sq_h1 = /** @type {(inputs: Funnel_Sq_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanza con tus [artículos académicos] sin tener que leerlos.`)
};

/**
* | output |
* | --- |
* | "Get through your [research papers] without reading them." |
*
* @param {Funnel_Sq_H1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_h1 = /** @type {((inputs?: Funnel_Sq_H1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_H1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_h1(inputs)
	return en_funnel_sq_h1(inputs)
});